import type { FaireCollectionEntity } from "../../entity_types/collection";

export const col_japandi_christmas: FaireCollectionEntity = {
  token: "col_japandi-christmas",
  type: "collection",
  name: "Japandi Christmas",
  description: "Minimalist holiday decor with natural textures.",
  thumbnailUrl:
    "https://images.unsplash.com/photo-1512474932049-78ac69ede12c?w=400&h=400&fit=crop",
  season: "winter",
  itemCount: 25,
  brandToken: "catalog_brand_audreys_home_gift",
  productTokens: [],
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
